import clsx from 'clsx';

import MainNavigation from './components/main-navigation/main-navigation';

import styles from './styles/header.module.css';

export default function Header() {
	return (
		<header className={clsx(styles['header'])}>
			<MainNavigation />
		</header>
	);
}
